webpackJsonp([21571696733600],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(130);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(92);
	var each = __webpack_require__(44).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(90);
	var Util = __webpack_require__(44);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(91);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(115);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleLeft = function FaArrowCircleLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 21.4v-2.8q0-0.6-0.5-1t-1-0.5h-11.2l4.3-4.2q0.4-0.4 0.4-1t-0.4-1l-2.1-2q-0.4-0.4-1-0.4t-1 0.4l-10.1 10.1q-0.4 0.4-0.4 1t0.4 1l10.1 10.1q0.4 0.4 1 0.4t1-0.4l2.1-2q0.4-0.4 0.4-1t-0.4-1l-4.3-4.2h11.2q0.6 0 1-0.5t0.5-1z m5.7-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleLeft;
	module.exports = exports['default'];

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleRight = function FaArrowCircleRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.7 20q0-0.6-0.4-1l-10.1-10.1q-0.4-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1t0.4 1l4.3 4.2h-11.3q-0.5 0-1 0.5t-0.4 1v2.8q0 0.6 0.4 1t1 0.5h11.3l-4.3 4.2q-0.4 0.4-0.4 1t0.4 1l2.1 2q0.4 0.4 1 0.4t1-0.4l10.1-10.1q0.4-0.4 0.4-1z m5.6 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleRight;
	module.exports = exports['default'];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(58);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdClose = function MdClose(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 10.7l-9.3 9.3 9.3 9.3-2.3 2.3-9.3-9.3-9.3 9.3-2.3-2.3 9.3-9.3-9.3-9.3 2.3-2.3 9.3 9.3 9.3-9.3z' })
	        )
	    );
	};
	
	exports.default = MdClose;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(103);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(45);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(46);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var isOpen = newProps.isOpen;
	      // Stop unnecessary renders if modal is remaining closed
	
	      if (!this.props.isOpen && !isOpen) return;
	
	      var currentParent = getParentElement(this.props.parentSelector);
	      var newParent = getParentElement(newProps.parentSelector);
	
	      if (newParent !== currentParent) {
	        currentParent.removeChild(this.node);
	        newParent.appendChild(this.node);
	      }
	
	      !isReact16 && this.renderPortal(newProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(newProps) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      if (newProps.portalClassName !== this.props.portalClassName) {
	        this.node.className = newProps.portalClassName;
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	exports.default = Modal;

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(105);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(106);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(45);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(104);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(46);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setFocusAfterRender = function (focus) {
	      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
	    };
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	      _this.moveFromContentToOverlay = null;
	    };
	
	    _this.handleOverlayOnMouseUp = function () {
	      if (_this.moveFromContentToOverlay === null) {
	        _this.shouldClose = false;
	      }
	      if (_this.props.shouldCloseOnOverlayClick) {
	        _this.shouldClose = true;
	      }
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.ariaAttributes = function (items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc["aria-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Focus needs to be set when mounting and already open
	      if (this.props.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(newProps) {
	      if (false) {
	        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (newProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	      // Focus only needs to be set once when the modal is being opened
	      if (!this.props.isOpen && newProps.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      } else if (this.props.isOpen && !newProps.isOpen) {
	        this.close();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.focusAfterRender) {
	        this.focusContent();
	        this.setFocusAfterRender(false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.afterClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown,
	          onMouseUp: this.handleOverlayOnMouseUp,
	          "aria-modal": "true"
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.ariaAttributes(this.props.aria || {})),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  }
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string") {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(47);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(54);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(47);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prune, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(102);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(35);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    // init: function hook that gets called right before InnerSlider mounts
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow should react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	exports.default = defaultProps;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(112);

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(111);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(35);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(109);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(48);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(89);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(113);
	
	var _dots = __webpack_require__(108);
	
	var _arrows = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null, // wraps the track
	  track: null, // component that rolls out like a film
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    // number of slides shown in the active frame
	    var slidesToShow = this.props.slidesToShow;
	    var childrenLen = _react2.default.Children.count(this.props.children);
	    var currentSlide = this.state.currentSlide;
	    for (var i = 0; i < childrenLen; i++) {
	      // if currentSlide is the lastSlide of current frame and 
	      // rest of the active slides are on the left of currentSlide
	      // then the following might cause a problem
	      if (i >= currentSlide && i < currentSlide + slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	    if (this.props.centerMode === true) {
	      // add slides to show on the left in case of centerMode with lazyLoad
	      var additionalCount = Math.floor(slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) {
	        additionalCount += 1;
	      }
	      var additionalNum = currentSlide;
	      while (additionalCount--) {
	        lazyLoadedList.push((--additionalNum + childrenLen) % childrenLen);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.lazyLoad && this.props.centerMode) {
	      var childrenLen = _react2.default.Children.count(this.props.children);
	      var additionalCount = Math.floor(this.props.slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) additionalCount++;
	      var leftMostSlide = (this.state.currentSlide - additionalCount + childrenLen) % childrenLen;
	      var rightMostSlide = (this.state.currentSlide + additionalCount) % childrenLen;
	      if (!this.state.lazyLoadedList.includes(leftMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [leftMostSlide]
	        });
	      }
	      if (!this.state.lazyLoadedList.includes(rightMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [rightMostSlide]
	        });
	      }
	    }
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(50);
	
	var _helpers = __webpack_require__(35);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      if (!this.props.rtl) {
	        swipeLeft = curLeft + touchSwipeLength * positionOffset;
	      } else {
	        swipeLeft = curLeft - touchSwipeLength * positionOffset;
	      }
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var currentIndex = this.props.rtl === true ? this.state.slideCount - this.state.currentSlide : this.state.currentSlide;
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(50);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  // supposed to start autoplay of slides
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	      // this reference isn't lost due to mixin
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        var elem = slickList.querySelector(selector) || {};
	        slickList.style.height = (elem.offsetHeight || 0) + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      if (targetLeft === currentLeft) {
	        targetSlide = currentSlide;
	      }
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return 'left';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return 'right';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	exports.getPreClones = getPreClones;
	exports.getPostClones = getPostClones;
	exports.getTotalSlides = getTotalSlides;
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// checks if spec is the superset of keys in keysArray, i.e., spec contains all the keys from keysArray
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow; // this should probably be getTotalSlides
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	    trackWidth += spec.slideWidth / 2; // this is a temporary hack so that track div doesn't create new row for slight overflow
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	  if (spec.fade) {
	    style = {
	      opacity: 1
	    };
	  }
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var lastSlide = _reactDom2.default.findDOMNode(trackRef).children[slideCount - 1];
	    var max = -lastSlide.offsetLeft + listWidth - lastSlide.offsetWidth;
	    if (slideCount <= slidesToShow || infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[slideIndex];
	    } else {
	      targetSlideIndex = slideIndex + slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      if (infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex + slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	    if (spec.infinite === false && targetLeft < max) {
	      targetLeft = max;
	    }
	  }
	
	  return targetLeft;
	};
	
	function getPreClones(spec) {
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	}
	
	function getPostClones(spec) {
	  return spec.slideCount;
	}
	
	function getTotalSlides(spec) {
	  return getPreClones(spec) + spec.slideCount + getPostClones(spec);
	}

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(110);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(94);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(48);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(78);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(93);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        // when not using server side rendering
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.slickPause = function slickPause() {
	    this.innerSlider.pause();
	  };
	
	  Slider.prototype.slickPlay = function slickPlay() {
	    this.innerSlider.autoPlay();
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      // never executes in the first render
	      // so defaultProps should be already there in this.props
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 in centerMode, you are using ' + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== 'production') {
	        console.warn('slidesToShow should be equal to 1 when fade is true, you\'re using ' + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 when fade is true, you\'re using ' + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === 'string') {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  // if spec has currentSlideIndex, we can also apply slickCurrent class according to that (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2300-L2302)
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    // if we're going right to left, index is reversed
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    // index of the slide
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0; // concern: not sure if this should be correct (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2328-L2346)
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    // concern: following can be incorrect in case where currentSlide is lastSlide in frame and rest of the slides to show have index smaller than currentSlideIndex
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= spec.slidesToShow + (spec.centerMode ? 1 : 0) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    // var slides = renderSlides.call(this, this.props);
	    var slides = renderSlides(this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/affSpice.4a2e6151.png";

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/homeAffiliations.4bf30dc9.png";

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMxaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzOCA3OS4xNTk4MjQsIDIwMTYvMDkvMTQtMDE6MDk6MDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE3IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkMyNTM3QkZEMDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkMyNTM3QkZFMDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QzI1MzdCRkIwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QzI1MzdCRkMwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wAARCAA/ABwDAREAAhEBAxEB/8QAWwABAQEBAAAAAAAAAAAAAAAAAAEEBwEBAAAAAAAAAAAAAAAAAAAAABABAQEAAQIGAwAAAAAAAAAAAQIAESFBMVFxQmIEQ1MFEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwDrGBgYGBgYGBgYAK8HVcFqaimaGal4qXoidnBMDBvA/nwVXX71HMT+ofc/N7eXrgwKqq8r4uBgYN8p/Qginj70nEU/lD2vzO3n64MCIonCeJgYGAKPJ44LVVdNUtVTzVPVV7uCYGBgYGBgYGBg/9k="

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMxaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzOCA3OS4xNTk4MjQsIDIwMTYvMDkvMTQtMDE6MDk6MDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE3IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkMyNTM3QkY5MDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkMyNTM3QkZBMDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QzI1MzdCRjcwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QzI1MzdCRjgwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wAARCAA/ABwDAREAAhEBAxEB/8QAXAABAQEBAQAAAAAAAAAAAAAAAAEDBAcBAQAAAAAAAAAAAAAAAAAAAAAQAAICAQMEAwAAAAAAAAAAAAABAgMSESEEMUFRE4HBMxEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A9YAAAAAAAAAALhPBTxeDbSlptqt2tfkCAAAHRxOUqsqrY+zjWfpX326Sj4kgJyuK6JRcZeymxZU2rpJfTXdAYAAOjicVW5W2y9fGr/Szvv0jHzJgTlcp3yiox9dNaxqqXSK+2+7AwAAXOeChk8E21HXbV7N6fAEAAAAAAAAAAAH/2Q=="

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ourStoryImg.67dc3ee0.png";

/***/ }),

/***/ 848:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ropeHome.1f21df26.png";

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/section1BG.393a9940.jpg";

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/storyBG.6566a811.jpg";

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/teamBG.2f8aa5c7.jpg";

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/videoBG.ad5b156b.jpg";

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-size: cover;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-size: cover;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  background: #fff;\n  padding: 50px 16px 32px;\n  width: 100%;\n  margin: 100px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  \n  @media(min-width: 768px){\n      padding: 60px 32px;\n  }\n   @media(min-width: 992px){\n    padding: 100px 80px 64px;\n    width: 1100px;\n  }\n   @media(min-width: 1200px){\n  \n  }\n'], ['\n  position: relative;\n  background: #fff;\n  padding: 50px 16px 32px;\n  width: 100%;\n  margin: 100px 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  \n  @media(min-width: 768px){\n      padding: 60px 32px;\n  }\n   @media(min-width: 992px){\n    padding: 100px 80px 64px;\n    width: 1100px;\n  }\n   @media(min-width: 1200px){\n  \n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  z-index: 1;\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 32px;\n  }\n\n  @media(min-width: 992px) {\n    font-size: 50px;\n    margin-bottom: 40px;\n  }\n  \n  @media(min-width: 1200px) {\n    margin-bottom: 50px;\n  }\n'], ['\n  z-index: 1;\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 32px;\n  }\n\n  @media(min-width: 992px) {\n    font-size: 50px;\n    margin-bottom: 40px;\n  }\n  \n  @media(min-width: 1200px) {\n    margin-bottom: 50px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 10%;\n  z-index: 0;\n'], ['\n  position: absolute;\n  top: 10%;\n  z-index: 0;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 12px;\n  text-align: center;\n  \n  @media(min-width: 768px) {\n    margin-bottom: 28px;\n  }\n\n @media(min-width: 992px) {\n    margin-bottom: 36px;\n  }\n  \n   @media(min-width: 1200px) {\n    margin-bottom: 46px;\n  }\n\n'], ['\n  margin-bottom: 12px;\n  text-align: center;\n  \n  @media(min-width: 768px) {\n    margin-bottom: 28px;\n  }\n\n @media(min-width: 992px) {\n    margin-bottom: 36px;\n  }\n  \n   @media(min-width: 1200px) {\n    margin-bottom: 46px;\n  }\n\n']);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	var _Container = __webpack_require__(10);
	
	var _aboutBG = __webpack_require__(833);
	
	var _aboutBG2 = _interopRequireDefault(_aboutBG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _Container.HeroContainer.extend(_templateObject);
	
	var AboutContainer = _styledComponents2.default.div(_templateObject2);
	
	var AboutTitle = _Kit.SectionTitle.extend(_templateObject3);
	
	var AboutBG = _styledComponents2.default.img(_templateObject4);
	
	var AboutSubtitle = _Kit.Subtitle.extend(_templateObject5);
	
	var Header = function Header(props) {
	  var _props$data = props.data,
	      header = _props$data.header,
	      subheader = _props$data.subheader,
	      paragraph = _props$data.paragraph,
	      _props$data$backgroun = _props$data.background_image,
	      source_url = _props$data$backgroun.source_url,
	      alt_text = _props$data$backgroun.alt_text;
	
	  return React.createElement(
	    Container,
	    {
	      style: { background: 'url(' + source_url + ') no-repeat bottom' }
	    },
	    React.createElement(
	      AboutContainer,
	      null,
	      React.createElement(AboutBG, { src: _aboutBG2.default }),
	      React.createElement(AboutTitle, {
	        dangerouslySetInnerHTML: { __html: header }
	      }),
	      React.createElement(AboutSubtitle, {
	        dangerouslySetInnerHTML: { __html: subheader }
	      }),
	      React.createElement(_Kit.P2, {
	        dangerouslySetInnerHTML: { __html: paragraph }
	      })
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n     @media (min-width: 768px) {\n        background: url(', ') top no-repeat;\n        background-size: contain;\n        padding-top: 60px;\n        padding-bottom: 120px;\n      }\n'], ['\n     @media (min-width: 768px) {\n        background: url(', ') top no-repeat;\n        background-size: contain;\n        padding-top: 60px;\n        padding-bottom: 120px;\n      }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 20px;\n  }\n  \n  @media(min-width: 992px) {\n    margin-bottom: 24px;\n  }\n'], ['\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 20px;\n  }\n  \n  @media(min-width: 992px) {\n    margin-bottom: 24px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 24px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 35px;\n  }\n  \n  @media(min-width: 992px) {\n    margin-bottom: 60px;\n  }\n'], ['\n  margin-bottom: 24px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 35px;\n  }\n  \n  @media(min-width: 992px) {\n    margin-bottom: 60px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 1fr;\n  width: 100%;\n  grid-column-gap: 32px;\n  @media(min-width: 768px){\n    grid-template-columns: repeat(4, 1fr);\n    \n  }\n'], ['\n  display: grid;\n  grid-template-columns: 1fr;\n  width: 100%;\n  grid-column-gap: 32px;\n  @media(min-width: 768px){\n    grid-template-columns: repeat(4, 1fr);\n    \n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	var _section1BG = __webpack_require__(226);
	
	var _section1BG2 = _interopRequireDefault(_section1BG);
	
	var _Kit = __webpack_require__(6);
	
	var _ValueCards = __webpack_require__(364);
	
	var _ValueCards2 = _interopRequireDefault(_ValueCards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject, _section1BG2.default);
	
	var StyledSectionTitle = _Kit.SectionTitle.extend(_templateObject2);
	
	var SectionDescription = _Kit.P1.extend(_templateObject3);
	
	var ValueContainer = _styledComponents2.default.div(_templateObject4);
	
	var ValuesData = [{
	  letter: 'F',
	  title: 'Family',
	  description: 'We strive to treat our customers, vendors, and employees like family.'
	}, {
	  letter: 'I',
	  title: 'Integrity',
	  description: 'We up-hold the highest standard of ethical conduct, honesty, and integrity.'
	}, {
	  letter: 'S',
	  title: 'Service',
	  description: 'We are diligent in our desire to provide our customers the best service in the business.'
	}, {
	  letter: 'H',
	  title: 'Hard Work',
	  description: 'We trust that we will achieve our goals and mission through hard work.'
	}];
	
	var Mission = function Mission(props) {
	  var _props$data = props.data,
	      header = _props$data.header,
	      paragraph = _props$data.paragraph;
	
	  return _react2.default.createElement(
	    StyledBodyContainer,
	    null,
	    _react2.default.createElement(StyledSectionTitle, {
	      dangerouslySetInnerHTML: { __html: header }
	    }),
	    _react2.default.createElement(SectionDescription, {
	      dangerouslySetInnerHTML: { __html: paragraph }
	    }),
	    _react2.default.createElement(
	      ValueContainer,
	      null,
	      ValuesData.map(function (i) {
	        return _react2.default.createElement(_ValueCards2.default, { key: i.title, letter: i.letter, title: i.title,
	          description: i.description });
	      })
	    )
	  );
	};
	
	exports.default = Mission;
	module.exports = exports['default'];

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-size: cover;\n  padding-bottom: 100px;\n  display: flex;\n  flex-direction: column;\n  \n  @media(max-width: 9000px){\n    padding-top: 0;\n  }\n  \n  h3 {\n  color: white;\n  }\n  \n  .slick-dots {\n    bottom: -50px;\n  }\n  \n  .slick-dots .slick-active div{\n    background: #fff;\n  }\n  \n   @media(min-width: 768px) {\n    padding-bottom: 100px;\n  }\n   @media(min-width: 992px) {\n    padding-bottom: 150px;\n  }\n  \n  @media(min-width: 1200px) {\n    padding-bottom: 200px;\n  }\n'], ['\n  background-size: cover;\n  padding-bottom: 100px;\n  display: flex;\n  flex-direction: column;\n  \n  @media(max-width: 9000px){\n    padding-top: 0;\n  }\n  \n  h3 {\n  color: white;\n  }\n  \n  .slick-dots {\n    bottom: -50px;\n  }\n  \n  .slick-dots .slick-active div{\n    background: #fff;\n  }\n  \n   @media(min-width: 768px) {\n    padding-bottom: 100px;\n  }\n   @media(min-width: 992px) {\n    padding-bottom: 150px;\n  }\n  \n  @media(min-width: 1200px) {\n    padding-bottom: 200px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: grid !important;\n  position: relative;\n  flex-direction: column;\n  grid-template-columns: 1fr;\n  grid-template-rows: 300px 400px;\n  \n  @media(min-width: 992px) {\n    flex-direction: row;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 650px;\n  }\n  \n  @media(min-width: 1200px) {\n    grid-template-rows: 725px;\n  }\n  \n '], ['\n  display: grid !important;\n  position: relative;\n  flex-direction: column;\n  grid-template-columns: 1fr;\n  grid-template-rows: 300px 400px;\n  \n  @media(min-width: 992px) {\n    flex-direction: row;\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 650px;\n  }\n  \n  @media(min-width: 1200px) {\n    grid-template-rows: 725px;\n  }\n  \n ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  padding: 25px 30px;\n  background: #fff;\n  order: 2;\n  overflow: auto;\n  svg{\n    display: none;\n  }\n  \n  @media(min-width: 992px) {\n    order: 1;\n    padding: 45px 60px;\n    \n    svg {\n      display: initial;\n      position:absolute;\n      bottom: 1%;\n      left: 1%;\n      cursor: pointer;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  padding: 25px 30px;\n  background: #fff;\n  order: 2;\n  overflow: auto;\n  svg{\n    display: none;\n  }\n  \n  @media(min-width: 992px) {\n    order: 1;\n    padding: 45px 60px;\n    \n    svg {\n      display: initial;\n      position:absolute;\n      bottom: 1%;\n      left: 1%;\n      cursor: pointer;\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  order: 1;\n  position: relative;\n  svg {\n    display: none;\n  }\n  \n  @media(min-width: 992px) {\n    order: 2;\n    \n    svg {\n        display: initial;\n        position: absolute;\n        bottom: 1%;\n        right: 1%;\n        cursor: pointer;\n    }\n  }\n  \n'], ['\n  order: 1;\n  position: relative;\n  svg {\n    display: none;\n  }\n  \n  @media(min-width: 992px) {\n    order: 2;\n    \n    svg {\n        display: initial;\n        position: absolute;\n        bottom: 1%;\n        right: 1%;\n        cursor: pointer;\n    }\n  }\n  \n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n'], ['\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n \n  p{\n    text-align: left;\n    font-family: Cabin, sans-serif;\n    color: #737373;\n    //font-size: 14px;\n    line-height: 1.5;\n    z-index: 1;\n  \n    margin-bottom: 20px;\n    \n    //@media(min-width: 768px) {\n    //  margin-bottom: 40px;\n    //}\n  }\n\n  @media(min-width: 992px){\n    text-align: left;\n  }\n'], ['\n \n  p{\n    text-align: left;\n    font-family: Cabin, sans-serif;\n    color: #737373;\n    //font-size: 14px;\n    line-height: 1.5;\n    z-index: 1;\n  \n    margin-bottom: 20px;\n    \n    //@media(min-width: 768px) {\n    //  margin-bottom: 40px;\n    //}\n  }\n\n  @media(min-width: 992px){\n    text-align: left;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 16px;\n  \n  @media(min-width: 992px){\n    text-align: left;\n  }\n'], ['\n  margin-bottom: 16px;\n  \n  @media(min-width: 992px){\n    text-align: left;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  border: 1px solid #fff;\n  border-radius: 50%;\n  background: transparent;\n  width: 20px;\n  height: 20px;\n'], ['\n  border: 1px solid #fff;\n  border-radius: 50%;\n  background: transparent;\n  width: 20px;\n  height: 20px;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  bottom: 1%;\n  //display: flex;\n  //justify-content: space-around;\n  width: 100%;\n  \n  svg {\n    bottom: 5px;\n  }\n  \n  svg:first-child {\n    position: absolute;\n    left: 5px;\n  }\n  \n  svg:last-child {\n    position: absolute;\n    right: 15px;\n  }\n  \n  @media(min-width: 992px){\n    display: none;\n  }\n'], ['\n  position: absolute;\n  bottom: 1%;\n  //display: flex;\n  //justify-content: space-around;\n  width: 100%;\n  \n  svg {\n    bottom: 5px;\n  }\n  \n  svg:first-child {\n    position: absolute;\n    left: 5px;\n  }\n  \n  svg:last-child {\n    position: absolute;\n    right: 15px;\n  }\n  \n  @media(min-width: 992px){\n    display: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arrowCircleRight = __webpack_require__(773);
	
	var _arrowCircleRight2 = _interopRequireDefault(_arrowCircleRight);
	
	var _arrowCircleLeft = __webpack_require__(772);
	
	var _arrowCircleLeft2 = _interopRequireDefault(_arrowCircleLeft);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Kit = __webpack_require__(6);
	
	var _OurStory = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledContainer = _Container.BodyContainer.extend(_templateObject);
	
	var StoryContainer = _styledComponents2.default.div(_templateObject2);
	
	var TextContainer = _styledComponents2.default.div(_templateObject3);
	
	var ImgContainer = _styledComponents2.default.figure(_templateObject4);
	
	var StoryImg = _styledComponents2.default.img(_templateObject5);
	
	var StoryText = _styledComponents2.default.div(_templateObject6);
	
	var StoryTitle = _Kit.CardTitle.extend(_templateObject7);
	
	var Circle = _styledComponents2.default.div(_templateObject8);
	
	var ArrowContainer = _styledComponents2.default.div(_templateObject9);
	
	var MrNgoStory = function (_Component) {
	  _inherits(MrNgoStory, _Component);
	
	  function MrNgoStory() {
	    _classCallCheck(this, MrNgoStory);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  MrNgoStory.prototype.next = function next() {
	    this.slider.slickNext();
	  };
	
	  MrNgoStory.prototype.previous = function previous() {
	    this.slider.slickPrev();
	  };
	
	  MrNgoStory.prototype.render = function render() {
	    var _this2 = this;
	
	    var settings = {
	      dots: true,
	      infinite: false,
	      customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	          'a',
	          null,
	          _react2.default.createElement(Circle, null)
	        );
	      },
	      arrows: false
	    };
	    var _props = this.props,
	        data = _props.data,
	        bgImage = _props.bgImage;
	    var background_image = bgImage.edges[0].node.acf.background_image;
	
	    return _react2.default.createElement(
	      StyledContainer,
	      {
	        style: { background: 'url(' + background_image.source_url + ') no-repeat bottom' }
	      },
	      _react2.default.createElement(_OurStory.AnchorPoint, { id: 'mrngosstory' }),
	      _react2.default.createElement(
	        _reactSlick2.default,
	        _extends({
	          ref: function ref(c) {
	            return _this2.slider = c;
	          }
	        }, settings),
	        data.map(function (i) {
	          return _react2.default.createElement(
	            StoryContainer,
	            null,
	            _react2.default.createElement(
	              TextContainer,
	              null,
	              _react2.default.createElement(StoryTitle, {
	                dangerouslySetInnerHTML: { __html: i.title }
	              }),
	              _react2.default.createElement(
	                StoryText,
	                null,
	                _react2.default.createElement(_Kit.P2, {
	                  dangerouslySetInnerHTML: { __html: i.story_text }
	                })
	              ),
	              _react2.default.createElement(_arrowCircleLeft2.default, {
	                onClick: function onClick() {
	                  return _this2.previous();
	                },
	                size: 30,
	                color: 'black'
	              })
	            ),
	            _react2.default.createElement(
	              ImgContainer,
	              null,
	              _react2.default.createElement(StoryImg, { src: i.source_url, alt: i.alt_text }),
	              _react2.default.createElement(_arrowCircleRight2.default, {
	                onClick: function onClick() {
	                  return _this2.next();
	                },
	                size: 30,
	                color: 'black'
	              })
	            ),
	            _react2.default.createElement(
	              ArrowContainer,
	              { className: 'mobileArrowContainer' },
	              _react2.default.createElement(_arrowCircleLeft2.default, {
	                onClick: function onClick() {
	                  return _this2.previous();
	                },
	                size: 20,
	                color: 'black'
	              }),
	              _react2.default.createElement(_arrowCircleRight2.default, {
	                onClick: function onClick() {
	                  return _this2.next();
	                },
	                size: 20,
	                color: 'black'
	              })
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return MrNgoStory;
	}(_react.Component);
	
	exports.default = MrNgoStory;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AnchorPoint = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @media(min-width: 768px) {\n  background: url(', ') no-repeat right;\n  background-size: contain;\n  }\n'], ['\n  @media(min-width: 768px) {\n  background: url(', ') no-repeat right;\n  background-size: contain;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  grid-template-areas: \n        \'img\' \n        \'title\'\n        \'story\';\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 3fr 2fr;\n      grid-template-areas: \n        \'title .\' \n        \'story img\';\n      grid-column-gap: 36px;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  grid-template-areas: \n        \'img\' \n        \'title\'\n        \'story\';\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 3fr 2fr;\n      grid-template-areas: \n        \'title .\' \n        \'story img\';\n      grid-column-gap: 36px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  grid-area: title;\n  text-align: left;\n'], ['\n  grid-area: title;\n  text-align: left;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  grid-area: story;\n  align-self: start;\n  text-align: left;\n  \n  p{\n    text-align: left;\n    margin-bottom: 20px;\n  }\n'], ['\n  grid-area: story;\n  align-self: start;\n  text-align: left;\n  \n  p{\n    text-align: left;\n    margin-bottom: 20px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  grid-area: img;\n  width: 100%;\n  height: auto;\n  order: 1;\n  \n  @media(min-width: 768px) {\n    order: 2;\n    align-self: start;\n  }\n'], ['\n  grid-area: img;\n  width: 100%;\n  height: auto;\n  order: 1;\n  \n  @media(min-width: 768px) {\n    order: 2;\n    align-self: start;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-top: -60px; \n  padding-top: 60px; \n  -webkit-background-clip: content-box;\n  background-clip: content-box;\n  \n  @media(min-width: 768px) {\n   margin-top: -100px; \n   padding-top: 100px; \n  }\n'], ['\n  margin-top: -60px; \n  padding-top: 60px; \n  -webkit-background-clip: content-box;\n  background-clip: content-box;\n  \n  @media(min-width: 768px) {\n   margin-top: -100px; \n   padding-top: 100px; \n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	var _ourStoryImg = __webpack_require__(225);
	
	var _ourStoryImg2 = _interopRequireDefault(_ourStoryImg);
	
	var _Kit = __webpack_require__(6);
	
	var _storyBG = __webpack_require__(227);
	
	var _storyBG2 = _interopRequireDefault(_storyBG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledContainer = _Container.BodyContainer.extend(_templateObject, _storyBG2.default);
	
	var InnerContainer = _styledComponents2.default.div(_templateObject2);
	
	var StoryHeader = _Kit.CardTitle.extend(_templateObject3);
	
	var StoryText = _styledComponents2.default.div(_templateObject4);
	
	var StoryImg = _styledComponents2.default.img(_templateObject5);
	
	var AnchorPoint = exports.AnchorPoint = _styledComponents2.default.div(_templateObject6);
	
	var OurStory = function OurStory(props) {
	  var _props$data = props.data,
	      title = _props$data.title,
	      content = _props$data.content;
	
	  return _react2.default.createElement(
	    StyledContainer,
	    null,
	    _react2.default.createElement(AnchorPoint, { id: 'ourstory' }),
	    _react2.default.createElement(
	      InnerContainer,
	      null,
	      _react2.default.createElement(StoryHeader, {
	        dangerouslySetInnerHTML: { __html: title }
	      }),
	      _react2.default.createElement(
	        StoryText,
	        null,
	        _react2.default.createElement(_Kit.P2, {
	          dangerouslySetInnerHTML: { __html: content }
	        })
	      ),
	      _react2.default.createElement(StoryImg, { src: _ourStoryImg2.default, alt: 'H & N Fish Co. Distribution center San Francisco' })
	    )
	  );
	};
	
	exports.default = OurStory;

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  @media(min-width: 768px){\n  background: url(', ') no-repeat;\n  background-size: cover;\n }\n  \n  @media(min-width: 768px){\n    padding: 40px 100px 0;\n  }\n  \n  @media(min-width: 992px) {\n    padding: 50px 120px 0;\n  }\n  \n  @media(min-width: 1200px) {\n    padding: 50px 180px 0;\n  }\n'], ['\n  @media(min-width: 768px){\n  background: url(', ') no-repeat;\n  background-size: cover;\n }\n  \n  @media(min-width: 768px){\n    padding: 40px 100px 0;\n  }\n  \n  @media(min-width: 992px) {\n    padding: 50px 120px 0;\n  }\n  \n  @media(min-width: 1200px) {\n    padding: 50px 180px 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-top: 24px;\n  display: grid;\n  grid-gap: 36px;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  \n  .empty {\n    display: none;\n  }\n  \n  @media(min-width: 768px){\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    grid-gap: 36px;\n    \n    .empty{\n      display: block;\n    }\n  }\n  \n  \n'], ['\n  margin-top: 24px;\n  display: grid;\n  grid-gap: 36px;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  \n  .empty {\n    display: none;\n  }\n  \n  @media(min-width: 768px){\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    grid-gap: 36px;\n    \n    .empty{\n      display: block;\n    }\n  }\n  \n  \n']),
	    _templateObject3 = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	var _Kit = __webpack_require__(6);
	
	var _TeamCard = __webpack_require__(360);
	
	var _TeamCard2 = _interopRequireDefault(_TeamCard);
	
	var _teamBG = __webpack_require__(851);
	
	var _teamBG2 = _interopRequireDefault(_teamBG);
	
	var _OurStory = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject, _teamBG2.default);
	
	var TeamGrid = _styledComponents2.default.div(_templateObject2);
	
	var PresidentCard = (0, _styledComponents2.default)(_TeamCard2.default)(_templateObject3);
	
	var Team = function (_Component) {
	  _inherits(Team, _Component);
	
	  function Team() {
	    _classCallCheck(this, Team);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Team.prototype.render = function render() {
	    var _props = this.props,
	        _onClick = _props.onClick,
	        team = _props.team;
	
	    var president = team[0];
	    var teamData = team.slice(1);
	    return _react2.default.createElement(
	      StyledBodyContainer,
	      null,
	      _react2.default.createElement(_OurStory.AnchorPoint, { id: 'team' }),
	      _react2.default.createElement(
	        _Kit.CardTitle,
	        null,
	        'GET TO KNOW OUR TEAM'
	      ),
	      _react2.default.createElement(
	        _Kit.P2,
	        null,
	        'Click images for more information'
	      ),
	      _react2.default.createElement(
	        TeamGrid,
	        null,
	        _react2.default.createElement('div', { className: 'empty' }),
	        _react2.default.createElement(PresidentCard, {
	          img: president.image.source_url,
	          alt: president.image.alt_text,
	          name: president.name,
	          position: president.position,
	          onClick: function onClick() {
	            return _onClick(president.id);
	          }
	        }),
	        _react2.default.createElement('div', { className: 'empty' }),
	        teamData.map(function (i) {
	          return _react2.default.createElement(_TeamCard2.default, {
	            key: i.name,
	            img: i.image.source_url,
	            alt: i.image.alt_text,
	            name: i.name,
	            position: i.position,
	            onClick: function onClick() {
	              return _onClick(i.id);
	            }
	          });
	        })
	      )
	    );
	  };
	
	  return Team;
	}(_react.Component);
	
	exports.default = Team;
	module.exports = exports['default'];

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  \n  img{\n    margin-bottom: 30px;\n    width: 100%;\n    cursor: pointer;\n    \n    :hover {\n      filter: opacity(.6);\n    }\n  }\n  \n  h1{\n    margin-bottom: 15px;\n    cursor: pointer;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  \n  img{\n    margin-bottom: 30px;\n    width: 100%;\n    cursor: pointer;\n    \n    :hover {\n      filter: opacity(.6);\n    }\n  }\n  \n  h1{\n    margin-bottom: 15px;\n    cursor: pointer;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var TeamCard = function (_Component) {
	  _inherits(TeamCard, _Component);
	
	  function TeamCard() {
	    _classCallCheck(this, TeamCard);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TeamCard.prototype.render = function render() {
	    var _props = this.props,
	        img = _props.img,
	        name = _props.name,
	        position = _props.position,
	        className = _props.className,
	        onClick = _props.onClick;
	
	    return _react2.default.createElement(
	      Container,
	      { className: className },
	      _react2.default.createElement('img', {
	        src: img,
	        alt: 'Team member img',
	        onClick: onClick
	      }),
	      _react2.default.createElement(
	        _Kit.ValueTitle,
	        { onClick: onClick },
	        name
	      ),
	      _react2.default.createElement(_Kit.P2, {
	        dangerouslySetInnerHTML: { __html: position }
	      })
	    );
	  };
	
	  return TeamCard;
	}(_react.Component);
	
	;
	
	exports.default = TeamCard;
	module.exports = exports['default'];

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: Cabin-Bold, sans-serif;\n  display: none;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  width: 200px;\n  \n  @media (min-width: 768px) {\n    display: flex;\n  }\n '], ['\n  font-family: Cabin-Bold, sans-serif;\n  display: none;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  width: 200px;\n  \n  @media (min-width: 768px) {\n    display: flex;\n  }\n ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background: #004a87;\n  color: #fff;\n  border-radius: 50%;\n\twidth: 50px;\n\theight: 50px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1;\n\tfont-family: Cabin-Bold, sans-serif;\n\tfont-size: 14px;\n\t\n\t@media(min-width: 1200px) {\n\t\twidth: 70px;\n\t  height: 70px;\n\t  font-size: 16px;\n\t}\n\t\n\t@media(min-width: 1680px) {\n\t\twidth: 80px;\n\t  height: 80px;\n\t  font-size: 22px;\n\t}\n'], ['\n  background: #004a87;\n  color: #fff;\n  border-radius: 50%;\n\twidth: 50px;\n\theight: 50px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1;\n\tfont-family: Cabin-Bold, sans-serif;\n\tfont-size: 14px;\n\t\n\t@media(min-width: 1200px) {\n\t\twidth: 70px;\n\t  height: 70px;\n\t  font-size: 16px;\n\t}\n\t\n\t@media(min-width: 1680px) {\n\t\twidth: 80px;\n\t  height: 80px;\n\t  font-size: 22px;\n\t}\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  font-family: Cabin-Bold, sans-serif;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: column;\n  \n  ', ';\n  \n  @media (min-width: 992px) {\n    font-size: 14px;\n  }\n  \n  @media (min-width: 1680px) {\n    font-size: 17px;\n  }\n'], ['\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  font-family: Cabin-Bold, sans-serif;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: column;\n  \n  ', ';\n  \n  @media (min-width: 992px) {\n    font-size: 14px;\n  }\n  \n  @media (min-width: 1680px) {\n    font-size: 17px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  background: #fff;\n  width: 100%;\n  ', '\n  \n  :before {\n    content: "";\n    background: #dedede;\n    width: 2px;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  background: #fff;\n  width: 100%;\n  ', '\n  \n  :before {\n    content: "";\n    background: #dedede;\n    width: 2px;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Bubble = _styledComponents2.default.div(_templateObject2);
	
	var Text = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.top ? 'top: 0;' : 'bottom: 0;';
	});
	
	var TextContainer = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.top ? 'bottom: 0; top: -125px;' : 'bottom: -125px; top: 0;';
	});
	
	var TimeBubble = function TimeBubble(props) {
	  var date = props.date,
	      text = props.text,
	      top = props.top;
	
	  return _react2.default.createElement(
	    Container,
	    { top: top },
	    top ? _react2.default.createElement(
	      TextContainer,
	      { top: top },
	      _react2.default.createElement(Text, {
	        top: top,
	        dangerouslySetInnerHTML: { __html: text }
	      })
	    ) : _react2.default.createElement(
	      Bubble,
	      null,
	      date
	    ),
	    top ? _react2.default.createElement(
	      Bubble,
	      null,
	      date
	    ) : _react2.default.createElement(
	      TextContainer,
	      null,
	      _react2.default.createElement(Text, {
	        top: top,
	        dangerouslySetInnerHTML: { __html: text }
	      })
	    )
	  );
	};
	
	exports.default = TimeBubble;
	module.exports = exports['default'];

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\n'], ['\n\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: space-between;\n  \n  @media(min-width: 768px) {\n      margin: 200px 0;\n  }\n'], ['\n  display: flex;\n  justify-content: space-between;\n  \n  @media(min-width: 768px) {\n      margin: 200px 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	var _TimeBubble = __webpack_require__(361);
	
	var _TimeBubble2 = _interopRequireDefault(_TimeBubble);
	
	var _TimelineSlider = __webpack_require__(363);
	
	var _TimelineSlider2 = _interopRequireDefault(_TimelineSlider);
	
	var _Kit = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject);
	
	var BubbleContainer = _styledComponents2.default.div(_templateObject2);
	
	var Timeline = function Timeline(props) {
	  var timeline = props.timeline;
	
	  return _react2.default.createElement(
	    StyledBodyContainer,
	    null,
	    _react2.default.createElement(
	      _Kit.CardTitle,
	      null,
	      'H & N TIMELINE'
	    ),
	    _react2.default.createElement(
	      BubbleContainer,
	      null,
	      timeline.map(function (i, index) {
	        var top = index % 2 === 0;
	        return _react2.default.createElement(_TimeBubble2.default, {
	          key: index,
	          date: i.year,
	          text: i.text,
	          top: top
	        });
	      }),
	      _react2.default.createElement(_TimelineSlider2.default, { data: timeline })
	    )
	  );
	};
	
	exports.default = Timeline;
	module.exports = exports['default'];

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: block;\n  width: 100%;\n  \n  @media (min-width: 768px) {\n    display: none;\n  }\n  \n  .slick-prev {\n    left: 0;\n    z-index: 10;\n  }\n  \n  .slick-next {\n    right: 0;\n    z-index: 10;\n  }\n'], ['\n  display: block;\n  width: 100%;\n  \n  @media (min-width: 768px) {\n    display: none;\n  }\n  \n  .slick-prev {\n    left: 0;\n    z-index: 10;\n  }\n  \n  .slick-next {\n    right: 0;\n    z-index: 10;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-family: Cabin-Bold, sans-serif;\n  display: flex !important;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  //width: 100px;\n \tmargin: 200px 0;\n\n  \n  @media (min-width: 768px) {\n    display: none;\n  }\n '], ['\n  font-family: Cabin-Bold, sans-serif;\n  display: flex !important;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  position: relative;\n  //width: 100px;\n \tmargin: 200px 0;\n\n  \n  @media (min-width: 768px) {\n    display: none;\n  }\n ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background: #004a87;\n  color: #fff;\n  border-radius: 50%;\n\twidth: 80px;\n\theight: 80px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1;\n\tfont-family: Cabin-Bold, sans-serif;\n\tfont-size: 22px;\n'], ['\n  background: #004a87;\n  color: #fff;\n  border-radius: 50%;\n\twidth: 80px;\n\theight: 80px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index: 1;\n\tfont-family: Cabin-Bold, sans-serif;\n\tfont-size: 22px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  font-family: Cabin-Bold, sans-serif;\n  font-size: 17px;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: column;\n  \n  ', ';\n'], ['\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  right: 0;\n  background: #fff;\n  font-family: Cabin-Bold, sans-serif;\n  font-size: 17px;\n  white-space: pre-line;\n  display: flex;\n  flex-direction: column;\n  \n  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  background: #fff;\n  width: 100%;\n  ', '\n  \n  :before {\n    content: "";\n    background: #dedede;\n    width: 2px;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: absolute;\n  background: #fff;\n  width: 100%;\n  ', '\n  \n  :before {\n    content: "";\n    background: #dedede;\n    width: 2px;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Affiliations = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SliderContainer = _styledComponents2.default.div(_templateObject);
	
	var Container = _styledComponents2.default.div(_templateObject2);
	
	var Bubble = _styledComponents2.default.div(_templateObject3);
	
	var Text = _styledComponents2.default.div(_templateObject4, function (props) {
	  return props.top ? 'top: 0;' : 'bottom: 0;';
	});
	
	var TextContainer = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.top ? 'bottom: 0; top: -125px;' : 'bottom: -125px; top: 0;';
	});
	
	var TimelineSlider = function (_Component) {
	  _inherits(TimelineSlider, _Component);
	
	  function TimelineSlider() {
	    _classCallCheck(this, TimelineSlider);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TimelineSlider.prototype.render = function render() {
	    var settings = {
	      dots: false,
	      nextArrow: _react2.default.createElement(_Affiliations.RightArrow, null),
	      prevArrow: _react2.default.createElement(_Affiliations.LeftArrow, null),
	      infinite: false,
	      speed: 500,
	      slidesToShow: 2,
	      slidesToScroll: 1,
	      autoplay: false
	    };
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      SliderContainer,
	      null,
	      _react2.default.createElement(
	        _reactSlick2.default,
	        settings,
	        data.map(function (i, index) {
	          var top = index % 2 === 0;
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(
	              Container,
	              { top: top },
	              top ? _react2.default.createElement(
	                TextContainer,
	                { top: top },
	                _react2.default.createElement(Text, {
	                  top: top,
	                  dangerouslySetInnerHTML: { __html: i.text }
	                })
	              ) : _react2.default.createElement(
	                Bubble,
	                null,
	                i.year
	              ),
	              top ? _react2.default.createElement(
	                Bubble,
	                null,
	                i.year
	              ) : _react2.default.createElement(
	                TextContainer,
	                null,
	                _react2.default.createElement(Text, {
	                  top: top,
	                  dangerouslySetInnerHTML: { __html: i.text }
	                })
	              )
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return TimelineSlider;
	}(_react.Component);
	
	exports.default = TimelineSlider;
	module.exports = exports['default'];

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    margin-bottom: 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-family: Cabin-Bold, sans-serif;\n  font-size: 80px;\n  color: #fff;\n  background-color: #90d2e4;\n  width: 40vw;\n  height: 40vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    font-size: 60px;\n    width: 10vw;\n    height: 10vw;\n    margin-bottom: 32px;\n  }\n  \n  @media(min-width: 992px){\n    font-size: 140px;\n    width: 15vw;\n    height: 15vw;\n  }\n  \n  @media(min-width: 1200px){\n    font-size: 180px;\n    //width: 280px;\n    //height: 280px;\n  }\n'], ['\n  font-family: Cabin-Bold, sans-serif;\n  font-size: 80px;\n  color: #fff;\n  background-color: #90d2e4;\n  width: 40vw;\n  height: 40vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 16px;\n  \n  @media(min-width: 768px){\n    font-size: 60px;\n    width: 10vw;\n    height: 10vw;\n    margin-bottom: 32px;\n  }\n  \n  @media(min-width: 992px){\n    font-size: 140px;\n    width: 15vw;\n    height: 15vw;\n  }\n  \n  @media(min-width: 1200px){\n    font-size: 180px;\n    //width: 280px;\n    //height: 280px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin-top: 8px;\n  \n  @media(min-width: 768px) {\n    margin-top: 16px;\n  }\n'], ['\n  margin-top: 8px;\n  \n  @media(min-width: 768px) {\n    margin-top: 16px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var LetterBox = _styledComponents2.default.div(_templateObject2);
	
	var ValueDescription = _Kit.P2.extend(_templateObject3);
	
	var ValueCards = function ValueCards(props) {
	  var letter = props.letter,
	      title = props.title,
	      description = props.description;
	
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      LetterBox,
	      null,
	      letter
	    ),
	    _react2.default.createElement(
	      _Kit.ValueTitle,
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      ValueDescription,
	      null,
	      description
	    )
	  );
	};
	
	exports.default = ValueCards;
	module.exports = exports['default'];

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 35vw;\n  z-index: 2;\n  \n  @media(min-width: 768px) {\n    //height: 50vw;\n  }\n'], ['\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 35vw;\n  z-index: 2;\n  \n  @media(min-width: 768px) {\n    //height: 50vw;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  width: 100%;\n  height: auto;\n  top: 0;\n  right: 0;\n  left: 0;\n  \n  @media(min-width: 768px) {\n    width: 100%;\n    height: auto;\n  }\n'], ['\n  position: absolute;\n  width: 100%;\n  height: auto;\n  top: 0;\n  right: 0;\n  left: 0;\n  \n  @media(min-width: 768px) {\n    width: 100%;\n    height: auto;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 50px;\n  height: 50px;\n  z-index: 1;\n  cursor: pointer;\n  \n  @media(min-width: 768px) {\n    width: auto;\n    height: auto;\n  }\n'], ['\n  width: 50px;\n  height: 50px;\n  z-index: 1;\n  cursor: pointer;\n  \n  @media(min-width: 768px) {\n    width: auto;\n    height: auto;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _videoBG = __webpack_require__(852);
	
	var _videoBG2 = _interopRequireDefault(_videoBG);
	
	var _playBtn = __webpack_require__(848);
	
	var _playBtn2 = _interopRequireDefault(_playBtn);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var VideoBackground = _styledComponents2.default.img(_templateObject2);
	
	var PlayButton = _styledComponents2.default.img(_templateObject3);
	
	var VideoSection = function (_Component) {
	  _inherits(VideoSection, _Component);
	
	  function VideoSection() {
	    _classCallCheck(this, VideoSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  VideoSection.prototype.render = function render() {
	    var onClick = this.props.onClick;
	
	    return _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(VideoBackground, { src: _videoBG2.default }),
	      _react2.default.createElement(PlayButton, { src: _playBtn2.default, onClick: onClick })
	    );
	  };
	
	  return VideoSection;
	}(_react.Component);
	
	exports.default = VideoSection;
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RightArrow = exports.LeftArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 32px 0 50px;\n  display: grid;\n  grid-row-gap: 24px;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(2, auto);\n  z-index: 1;\n  \n  @media(min-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    grid-column-gap: 24px;\n    align-items: center;\n  }\n  \n  @media(min-width: 992px) {\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n  \n  @media(min-width: 1200px) {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n'], ['\n  padding: 32px 0 50px;\n  display: grid;\n  grid-row-gap: 24px;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(2, auto);\n  z-index: 1;\n  \n  @media(min-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    grid-column-gap: 24px;\n    align-items: center;\n  }\n  \n  @media(min-width: 992px) {\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n  \n  @media(min-width: 1200px) {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: block;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    right: 0;\n    top: -2%;\n    z-index: 1;\n'], ['\n    display: block;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    right: 0;\n    top: -2%;\n    z-index: 1;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: none;\n  \n  @media(min-width: 768px) {\n      display: block;\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 65%;\n  }\n  \n  @media(min-width: 1200px) {\n    height: 80%\n  }\n  \n  @media(min-width: 1680px) {\n    height: auto;\n  }\n'], ['\n  display: none;\n  \n  @media(min-width: 768px) {\n      display: block;\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 65%;\n  }\n  \n  @media(min-width: 1200px) {\n    height: 80%\n  }\n  \n  @media(min-width: 1680px) {\n    height: auto;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 0 20px;\n  \n  @media(min-width: 992px) {\n    padding: 0;\n    \n    .slick-slider{\n        .slick-arrow{\n            display:none !important;\n        }\n        .slick-prev {\n          left: 0 !important;\n        }\n        .slick-next {\n          right: 0 !important;\n        }\n        &:hover{\n            .slick-arrow{\n                display:block !important;\n            }\n        }\n    }\n  }\n'], ['\n  padding: 0 20px;\n  \n  @media(min-width: 992px) {\n    padding: 0;\n    \n    .slick-slider{\n        .slick-arrow{\n            display:none !important;\n        }\n        .slick-prev {\n          left: 0 !important;\n        }\n        .slick-next {\n          right: 0 !important;\n        }\n        &:hover{\n            .slick-arrow{\n                display:block !important;\n            }\n        }\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n'], ['\n  display: flex;\n  justify-content: center;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  height: 64px !important;\n  \n  @media(min-width: 768px) {\n    height: initial !important;\n  }\n   \n'], ['\n  cursor: pointer;\n  height: 64px !important;\n  \n  @media(min-width: 768px) {\n    height: initial !important;\n  }\n   \n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  background: transparent;\n'], ['\n  background: transparent;\n']);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _CardButton = __webpack_require__(60);
	
	var _CardButton2 = _interopRequireDefault(_CardButton);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _homeAffiliations = __webpack_require__(116);
	
	var _homeAffiliations2 = _interopRequireDefault(_homeAffiliations);
	
	var _affSpice = __webpack_require__(75);
	
	var _affSpice2 = _interopRequireDefault(_affSpice);
	
	var _ropeHome = __webpack_require__(119);
	
	var _ropeHome2 = _interopRequireDefault(_ropeHome);
	
	var _Container = __webpack_require__(10);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _nextArrow = __webpack_require__(118);
	
	var _nextArrow2 = _interopRequireDefault(_nextArrow);
	
	var _leftArrow = __webpack_require__(117);
	
	var _leftArrow2 = _interopRequireDefault(_leftArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InnerContainer = (0, _styledComponents2.default)(_Container.BodyContainer)(_templateObject);
	
	var Rope = _styledComponents2.default.img(_templateObject2);
	
	var SpiceBG = _styledComponents2.default.img(_templateObject3);
	
	var AffiliationImg = _styledComponents2.default.img(_templateObject4);
	
	var SliderContainer = _styledComponents2.default.div(_templateObject5);
	
	var CarouselContainer = _styledComponents2.default.div(_templateObject6);
	
	var CarouselImg = _styledComponents2.default.img(_templateObject7);
	
	var AffiliationsCard = (0, _styledComponents2.default)(_CardButton2.default)(_templateObject8);
	
	var LeftArrow = exports.LeftArrow = function LeftArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return React.createElement('img', {
	        className: className,
	        onClick: onClick,
	        style: _extends({}, style, { height: 'auto', zIndex: '10' }),
	        src: _leftArrow2.default,
	        alt: 'previous arrow' });
	};
	var RightArrow = exports.RightArrow = function RightArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return React.createElement('img', {
	        className: className,
	        onClick: onClick,
	        style: _extends({}, style, { height: 'auto', zIndex: '10' }),
	        src: _nextArrow2.default,
	        alt: 'next arrow' });
	};
	
	var Affiliations = function Affiliations(props) {
	    var settings = {
	        dots: false,
	        nextArrow: React.createElement(RightArrow, null),
	        prevArrow: React.createElement(LeftArrow, null),
	        infinite: true,
	        speed: 500,
	        slidesToShow: 5,
	        slidesToScroll: 1,
	        autoplay: false,
	        responsive: [{
	            breakpoint: 1680,
	            settings: {
	                slidesToShow: 3,
	                slidesToScroll: 1,
	                infinite: true
	            }
	        }, {
	            breakpoint: 992,
	            settings: {
	                slidesToShow: 2,
	                slidesToScroll: 1
	            }
	        }]
	    };
	    var _props$data = props.data,
	        header = _props$data.header,
	        paragraph = _props$data.paragraph,
	        affiliateData = props.affiliateData;
	
	    return React.createElement(
	        _Container.BodyContainer,
	        null,
	        React.createElement(Rope, { src: _ropeHome2.default, alt: 'rope' }),
	        React.createElement(SpiceBG, { src: _affSpice2.default, alt: 'spice' }),
	        React.createElement(
	            InnerContainer,
	            null,
	            React.createElement(AffiliationImg, { src: _homeAffiliations2.default, alt: 'H & N Group Seafood Supplier' }),
	            React.createElement(AffiliationsCard, {
	                header: header,
	                subtitle: paragraph,
	                buttonText: 'Discover',
	                link: '/affiliations',
	                title: 'H & N Group Affilates'
	            })
	        ),
	        React.createElement(
	            SliderContainer,
	            null,
	            React.createElement(
	                _reactSlick2.default,
	                settings,
	                affiliateData.map(function (i) {
	                    var _i$node$acf = i.node.acf,
	                        name = _i$node$acf.name,
	                        link = _i$node$acf.link,
	                        logo = _i$node$acf.logo;
	
	                    return React.createElement(
	                        'a',
	                        {
	                            key: name,
	                            href: 'https://' + link,
	                            target: '_blank'
	                        },
	                        React.createElement(
	                            CarouselContainer,
	                            null,
	                            React.createElement(CarouselImg, { src: logo.source_url, alt: logo.alt_text })
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	exports.default = Affiliations;

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  padding: 50px 20px 32px ;\n  background: #fff;\n  align-items: center;\n  justify-content: center;\n  \n  .content {\n    margin: 16px 0;\n  }\n  \n  @media(min-width: 768px) {\n    justify-items: left;\n    align-items: left;\n  \n    h1, p {\n      text-align: left;\n    }\n    \n    padding: 30px 32px;\n  }\n  \n  @media(min-width: 992px){\n    padding: 60px 60px 50px;\n    \n    .content {\n      margin: 32px 0;\n    }\n  }\n  \n  a {\n        text-decoration: none;\n        color: #004a87;\n        width: 100%;\n        max-width: 120px;\n        height: 30px;\n          \n       @media(min-width: 768px){\n         max-width: 190px;\n         height: 48px;\n      }\n  }\n  \n  p{\n    margin: 10px 0;\n    \n    @media(min-width: 768px){\n        margin: 16px 0;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  padding: 50px 20px 32px ;\n  background: #fff;\n  align-items: center;\n  justify-content: center;\n  \n  .content {\n    margin: 16px 0;\n  }\n  \n  @media(min-width: 768px) {\n    justify-items: left;\n    align-items: left;\n  \n    h1, p {\n      text-align: left;\n    }\n    \n    padding: 30px 32px;\n  }\n  \n  @media(min-width: 992px){\n    padding: 60px 60px 50px;\n    \n    .content {\n      margin: 32px 0;\n    }\n  }\n  \n  a {\n        text-decoration: none;\n        color: #004a87;\n        width: 100%;\n        max-width: 120px;\n        height: 30px;\n          \n       @media(min-width: 768px){\n         max-width: 190px;\n         height: 48px;\n      }\n  }\n  \n  p{\n    margin: 10px 0;\n    \n    @media(min-width: 768px){\n        margin: 16px 0;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Kit = __webpack_require__(6);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var CardButton = function (_Component) {
	  _inherits(CardButton, _Component);
	
	  function CardButton() {
	    _classCallCheck(this, CardButton);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CardButton.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        subtitle = _props.subtitle,
	        buttonText = _props.buttonText,
	        className = _props.className,
	        link = _props.link,
	        header = _props.header;
	
	    return _react2.default.createElement(
	      Container,
	      { className: className },
	      _react2.default.createElement(
	        _Kit.CardTitle,
	        null,
	        header
	      ),
	      _react2.default.createElement(_Kit.P2, {
	        dangerouslySetInnerHTML: { __html: subtitle }
	      }),
	      link ? _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: link, title: title },
	        ' ',
	        _react2.default.createElement(
	          _Kit.OutlineButton,
	          null,
	          buttonText
	        )
	      ) : _react2.default.createElement(
	        _Kit.OutlineButton,
	        null,
	        buttonText
	      )
	    );
	  };
	
	  return CardButton;
	}(_react.Component);
	
	;
	
	exports.default = CardButton;
	module.exports = exports['default'];

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  position: relative;\n'], ['\n  display: flex;\n  position: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto minmax(auto, 300px);\n  margin: auto;\n  width: 75%;\n  position: relative;\n  \n  @media (min-width: 768px) {\n   grid-template-columns: 2fr 3fr;\n   grid-template-rows: 479px;\n   width: 100%;\n   max-width: 1200px;\n  }\n  \n  svg {\n    position: absolute;\n    top: 1%;\n    right: 1%;\n    cursor: pointer;\n    font-size: 30px;\n    color: #909090\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto minmax(auto, 300px);\n  margin: auto;\n  width: 75%;\n  position: relative;\n  \n  @media (min-width: 768px) {\n   grid-template-columns: 2fr 3fr;\n   grid-template-rows: 479px;\n   width: 100%;\n   max-width: 1200px;\n  }\n  \n  svg {\n    position: absolute;\n    top: 1%;\n    right: 1%;\n    cursor: pointer;\n    font-size: 30px;\n    color: #909090\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  \n  @media(min-width: 768px) {\n      width: auto;\n      height: 100%;\n      justify-self: end;\n  }\n'], ['\n  width: 100%;\n  \n  @media(min-width: 768px) {\n      width: auto;\n      height: 100%;\n      justify-self: end;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  padding: 40px;\n  overflow: auto;\n  \n  .bio p{\n    margin-bottom: 20px;\n    \n    @media(min-width: 768px) {\n      margin-bottom: 20px;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  padding: 40px;\n  overflow: auto;\n  \n  .bio p{\n    margin-bottom: 20px;\n    \n    @media(min-width: 768px) {\n      margin-bottom: 20px;\n    }\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  text-align: left;\n'], ['\n  text-align: left;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  text-align: left;\n  margin: 8px 0 12px;\n'], ['\n  text-align: left;\n  margin: 8px 0 12px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(72);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	var _close = __webpack_require__(101);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContentContainer = _styledComponents2.default.div(_templateObject);
	
	var TeamContainer = _styledComponents2.default.div(_templateObject2);
	
	var TeamImg = _styledComponents2.default.img(_templateObject3);
	
	var BioContainer = _styledComponents2.default.div(_templateObject4);
	
	var Name = _Kit.ValueTitle.extend(_templateObject5);
	
	var Title = _Kit.P2.extend(_templateObject6);
	
	var BioText = _Kit.P2.extend(_templateObject5);
	
	var TeamModal = function (_React$Component) {
	  _inherits(TeamModal, _React$Component);
	
	  function TeamModal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TeamModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      console.log(event.target.tagName);
	      if (event.target.tagName === "A") {
	        _this.props.close();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TeamModal.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        isOpen = _props.isOpen,
	        close = _props.close,
	        _props$modalData = _props.modalData,
	        name = _props$modalData.name,
	        position = _props$modalData.position,
	        content = _props$modalData.content,
	        image = _props$modalData.image;
	
	    return _react2.default.createElement(
	      _reactModal2.default,
	      {
	        isOpen: isOpen,
	        onRequestClose: function onRequestClose() {
	          return close();
	        },
	        style: {
	          overlay: {
	            position: 'fixed',
	            top: 0,
	            left: 0,
	            right: 0,
	            bottom: 0,
	            backgroundColor: 'rgba(0, 0, 0, 0.75)',
	            display: 'flex',
	            justifyContent: 'center',
	            alignItems: 'center'
	          },
	          content: {
	            position: 'relative',
	            top: 0,
	            left: 0,
	            right: 0,
	            bottom: 0,
	            border: 'none',
	            background: 'none',
	            padding: 0,
	            overflow: 'hidden',
	            WebkitOverflowScrolling: 'touch'
	          }
	        },
	        contentLabel: 'Modal'
	      },
	      _react2.default.createElement(
	        ContentContainer,
	        null,
	        _react2.default.createElement(
	          TeamContainer,
	          null,
	          _react2.default.createElement(TeamImg, {
	            src: image.source_url,
	            alt: image.alt_text
	          }),
	          _react2.default.createElement(
	            BioContainer,
	            null,
	            _react2.default.createElement(Name, {
	              dangerouslySetInnerHTML: { __html: name }
	            }),
	            _react2.default.createElement(Title, {
	              dangerouslySetInnerHTML: { __html: position }
	            }),
	            _react2.default.createElement(BioText, {
	              className: 'bio',
	              dangerouslySetInnerHTML: { __html: content },
	              onClick: function onClick(event) {
	                return _this2.handleClick(event);
	              }
	            })
	          ),
	          _react2.default.createElement(_close2.default, {
	            onClick: function onClick() {
	              return close();
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return TeamModal;
	}(_react2.default.Component);
	
	exports.default = TeamModal;
	module.exports = exports['default'];

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 300px;\n    max-width: 100%;\n\n @media (min-width: 768px) {\n     width: 600px;\n  }\n  \n  @media(min-width: 992px) {\n    width: 900px;  \n  }\n\n'], ['\n    width: 300px;\n    max-width: 100%;\n\n @media (min-width: 768px) {\n     width: 600px;\n  }\n  \n  @media(min-width: 992px) {\n    width: 900px;  \n  }\n\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: auto;\n  width: 100%;\n  position: relative;\n\tpadding-bottom: 56.25%; /* 16:9 */\n\tpadding-top: 25px;\n\theight: 0;\n  \n  iframe {\n    position: absolute;\n  \ttop: 0;\n\t  left: 0;\n  \twidth: 100%;\n\t  height: 100%;\n  }\n'], ['\n  margin: auto;\n  width: 100%;\n  position: relative;\n\tpadding-bottom: 56.25%; /* 16:9 */\n\tpadding-top: 25px;\n\theight: 0;\n  \n  iframe {\n    position: absolute;\n  \ttop: 0;\n\t  left: 0;\n  \twidth: 100%;\n\t  height: 100%;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(72);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MainContainer = _styledComponents2.default.div(_templateObject);
	
	var VideoContainer = _styledComponents2.default.div(_templateObject2);
	
	var VideoModal = function (_React$Component) {
	    _inherits(VideoModal, _React$Component);
	
	    function VideoModal() {
	        _classCallCheck(this, VideoModal);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    VideoModal.prototype.render = function render() {
	        var _props = this.props,
	            isOpen = _props.isOpen,
	            close = _props.close,
	            video = _props.video;
	
	        return _react2.default.createElement(
	            _reactModal2.default,
	            {
	                isOpen: isOpen,
	                onRequestClose: function onRequestClose() {
	                    return close();
	                },
	                style: {
	                    overlay: {
	                        position: 'fixed',
	                        top: 0,
	                        left: 0,
	                        right: 0,
	                        bottom: 0,
	                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
	                        display: 'flex',
	                        justifyContent: 'center',
	                        alignItems: 'center'
	                    },
	                    content: {
	                        position: 'relative',
	                        top: 0,
	                        left: 0,
	                        right: 0,
	                        bottom: 0,
	                        border: 'none',
	                        background: 'none',
	                        padding: 0,
	                        overflow: 'auto',
	                        WebkitOverflowScrolling: 'touch'
	                    }
	                },
	                contentLabel: 'Modal'
	            },
	            _react2.default.createElement(
	                MainContainer,
	                null,
	                _react2.default.createElement(
	                    VideoContainer,
	                    null,
	                    _react2.default.createElement('iframe', { width: '560', height: '349', src: video, frameBorder: '0',
	                        allowFullScreen: true })
	                )
	            )
	        );
	    };
	
	    return VideoModal;
	}(_react2.default.Component);
	
	exports.default = VideoModal;
	module.exports = exports['default'];

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getToKnowQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(356);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Mission = __webpack_require__(357);
	
	var _Mission2 = _interopRequireDefault(_Mission);
	
	var _VideoSection = __webpack_require__(365);
	
	var _VideoSection2 = _interopRequireDefault(_VideoSection);
	
	var _VideoModal = __webpack_require__(376);
	
	var _VideoModal2 = _interopRequireDefault(_VideoModal);
	
	var _OurStory = __webpack_require__(76);
	
	var _OurStory2 = _interopRequireDefault(_OurStory);
	
	var _Timeline = __webpack_require__(362);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _MrNgoStory = __webpack_require__(358);
	
	var _MrNgoStory2 = _interopRequireDefault(_MrNgoStory);
	
	var _Team = __webpack_require__(359);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _TeamModal = __webpack_require__(374);
	
	var _TeamModal2 = _interopRequireDefault(_TeamModal);
	
	var _hngutils = __webpack_require__(59);
	
	var _hngutils2 = _interopRequireDefault(_hngutils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GetToKnow = function (_Component) {
	    _inherits(GetToKnow, _Component);
	
	    function GetToKnow(props) {
	        _classCallCheck(this, GetToKnow);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            teamModalOpen: false,
	            teamModalId: "",
	            modalData: {},
	            videoModalOpen: false
	        };
	
	        _this.handleTeamClick = function (id) {
	            _this.setState({
	                teamModalOpen: true,
	                teamModalId: id
	            });
	        };
	
	        _this.handleVideoClick = function () {
	            _this.setState({
	                videoModalOpen: true
	            });
	        };
	
	        _this.handleTeamClose = function () {
	            _this.setState({
	                teamModalOpen: false,
	                teamModalId: ""
	            });
	        };
	
	        _this.handleVideoClose = function () {
	            _this.setState({
	                videoModalOpen: false
	            });
	        };
	
	        _this.props.data.allWordpressPage.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.image);
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.image_one);
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.image_two);
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.background_image);
	        });
	
	        _this.props.data.teamData.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.image);
	        });
	
	        _this.props.data.mrNgoStory.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.story_image);
	        });
	
	        _this.props.data.mrNgoStoryBG.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.background_image);
	        });
	        return _this;
	    }
	
	    GetToKnow.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props$data = this.props.data,
	            allWordpressPage = _props$data.allWordpressPage,
	            teamData = _props$data.teamData,
	            timelineData = _props$data.timelineData,
	            video = _props$data.video,
	            mrNgoStory = _props$data.mrNgoStory,
	            mrNgoStoryBG = _props$data.mrNgoStoryBG;
	
	        var mrNgoData = mrNgoStory.edges.map(function (i, index) {
	            var _i$node = i.node,
	                title = _i$node.title,
	                _i$node$acf = _i$node.acf,
	                story_text = _i$node$acf.story_text,
	                _i$node$acf$story_ima = _i$node$acf.story_image,
	                source_url = _i$node$acf$story_ima.source_url,
	                alt_text = _i$node$acf$story_ima.alt_text;
	
	            return { title: title, story_text: story_text, source_url: source_url, alt_text: alt_text, index: index };
	        });
	        var pageData = allWordpressPage.edges.map(function (i) {
	            var _i$node2 = i.node,
	                menu_order = _i$node2.menu_order,
	                title = _i$node2.title,
	                content = _i$node2.content,
	                acf = _i$node2.acf;
	
	            return { menu_order: menu_order, title: title, content: content, acf: acf };
	        }).sort(function (a, b) {
	            return a.menu_order - b.menu_order;
	        });
	        var team = teamData.edges.map(function (i) {
	            var _i$node3 = i.node,
	                id = _i$node3.id,
	                content = _i$node3.content,
	                _i$node3$acf = _i$node3.acf,
	                name = _i$node3$acf.name,
	                position = _i$node3$acf.position,
	                image = _i$node3$acf.image;
	
	            return {
	                id: id,
	                name: name,
	                position: position,
	                image: image,
	                content: content
	            };
	        });
	        var _state = this.state,
	            teamModalOpen = _state.teamModalOpen,
	            videoModalOpen = _state.videoModalOpen;
	
	        var selectedModal = team.filter(function (i) {
	            return i.id === _this2.state.teamModalId;
	        });
	        var timeline = timelineData.edges.map(function (i) {
	            var _i$node$acf2 = i.node.acf,
	                text = _i$node$acf2.text,
	                year = _i$node$acf2.year;
	
	            return { text: text, year: year };
	        }).sort(function (a, b) {
	            return a.year - b.year;
	        });
	        return _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(_Header2.default, { data: pageData[0].acf }),
	            _react2.default.createElement(_Mission2.default, { data: pageData[1].acf }),
	            _react2.default.createElement(_VideoSection2.default, { onClick: function onClick() {
	                    return _this2.handleVideoClick();
	                } }),
	            _react2.default.createElement(_VideoModal2.default, {
	                isOpen: videoModalOpen,
	                close: function close() {
	                    return _this2.handleVideoClose();
	                },
	                video: video.edges[0].node.acf.video_link
	            }),
	            _react2.default.createElement(_OurStory2.default, { data: pageData[3] }),
	            _react2.default.createElement(_Timeline2.default, { timeline: timeline }),
	            _react2.default.createElement(_MrNgoStory2.default, {
	                data: mrNgoData,
	                bgImage: mrNgoStoryBG
	            }),
	            teamModalOpen && _react2.default.createElement(_TeamModal2.default, {
	                isOpen: teamModalOpen,
	                close: function close() {
	                    return _this2.handleTeamClose();
	                },
	                modalData: selectedModal[0]
	            }),
	            _react2.default.createElement(_Team2.default, {
	                onClick: function onClick(id) {
	                    return _this2.handleTeamClick(id);
	                },
	                team: team
	            })
	        );
	    };
	
	    return GetToKnow;
	}(_react.Component);
	
	exports.default = GetToKnow;
	
	// get to know page wordpress_parent = 189
	
	var getToKnowQuery = exports.getToKnowQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-get-to-know-js-8a4727933393575fac66.js